import React from "react";
import clsx from "clsx";

interface ScrollableSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  error?: boolean;
  errorMessage?: string;
  maxHeight?: number; // Height in pixels
}

/**
 * A select component with a fixed height scrollable dropdown
 */
const ScrollableSelect: React.FC<ScrollableSelectProps> = ({
  className,
  error,
  errorMessage,
  maxHeight = 200,
  children,
  ...rest
}) => {
  // Apply the fixed height to the select dropdown
  const dropdownStyle = {
    "--select-dropdown-max-height": `${maxHeight}px`,
  } as React.CSSProperties;

  return (
    <div className="relative">
      <select
        className={clsx(
          "select w-full",
          error && "border-red-500 focus:ring-red-500",
          className,
        )}
        style={dropdownStyle}
        {...rest}
      >
        {children}
      </select>
      {error && errorMessage && (
        <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default ScrollableSelect;
